import apiService from '../Api'
import { AnswerResponse, CurrentStepResponse, ListParams, VideoQuizComplete, VideoQuizList } from './types'

export type StoreParams = {
  name: string
  email: string
  phone: string
}

export type StoreResponse = {
  uuid: string
}

export class VideoQuizService {
  async store(data: StoreParams): Promise<StoreResponse> {
    return apiService.post('/video-quiz/response', data).then((response) => response.data)
  }

  async getStepInfo(uuid: string): Promise<CurrentStepResponse> {
    return apiService.get(`/video-quiz/${uuid}/current-step`).then((response) => response.data)
  }

  async answer(uuid: string, questionId: number, answerId: number): Promise<AnswerResponse> {
    return apiService.post(`/video-quiz/${uuid}/answer/${questionId}/${answerId}`).then((response) => response.data)
  }

  async list(params: ListParams): Promise<VideoQuizList> {
    const queryParams = new URLSearchParams()
    queryParams.append('draw', params.draw.toString())
    queryParams.append('start', params.start.toString())
    queryParams.append('length', params.length.toString())
    queryParams.append('order[0][column]', params.order[0].column.toString())
    queryParams.append('order[0][dir]', params.order[0].dir)
    queryParams.append('search[value]', params.filters.search)
    queryParams.append('status', params.filters.status)
    queryParams.append('created_at[from]', params.filters.created_at.from)
    queryParams.append('created_at[to]', params.filters.created_at.to)

    return apiService.get('/video-quiz', { params: queryParams }).then((response) => response.data)
  }

  async get(id: number): Promise<VideoQuizComplete> {
    return apiService.get(`/video-quiz/${id}`).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/video-quiz/${id}`).then((response) => response.data)
  }
}
